import type { UserProfile } from "@/models/userProfile";
import axios from "axios";

export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await axios.get("/api/user-profile");
  return response.data;
};

export const updateUserProfile = async (
  userProfile: UserProfile
): Promise<UserProfile> => {
  const response = await axios.put("/api/user-profile", userProfile);
  return response.data;
};
